'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicSdk = require('@gig/magic-sdk');
var tslib = require('tslib');

var onCountryChange = function (fieldConfig) { return function (value, state, setField) { return tslib.__awaiter(void 0, void 0, void 0, function () {
    var phoneTypeStateValue, countries, phoneValue, phoneHidden;
    return tslib.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                phoneTypeStateValue = !!state.phone.value
                    ? state.phone.value
                    : '';
                return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'getCountries')()];
            case 1:
                countries = (_a.sent());
                return [4 /*yield*/, magicCommon.getPhoneValueAfterCountryChange(countries, phoneTypeStateValue, value)];
            case 2:
                phoneValue = _a.sent();
                phoneHidden = !magicCommon.objectValueOrDefault(fieldConfig.visibleForCountry, value);
                if (phoneValue) {
                    setField({
                        id: 'phone',
                        value: phoneValue,
                        touched: false,
                        isValidationPending: false,
                        hidden: phoneHidden,
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
/**
 * Depending on selected phone prefix, it retrieves the correct phone number validator
 *
 * @param fieldConfig the form state
 * @returns the regexp string needed to validate the phone number
 */
function getPhoneValidator(fieldConfig) {
    return function (data) {
        var _a;
        var phoneValue = ((_a = data === null || data === void 0 ? void 0 : data.phone) === null || _a === void 0 ? void 0 : _a.value) || '';
        var phonePrefix = magicCommon.convertPhoneValue(phoneValue)[0];
        if (phonePrefix && fieldConfig.numberValidator[phonePrefix]) {
            return fieldConfig.numberValidator[phonePrefix];
        }
        return fieldConfig.numberValidator.DEFAULT;
    };
}
function phone(fieldConfig) {
    var _this = this;
    return {
        id: 'phone',
        component: 'magic-ui-phone-number',
        isDataField: true,
        testId: 'step2-phone',
        properties: {
            'has-info': true,
            'class': 'form-field',
            'has-success': false,
            'message': magicCommon.translate('sign-up-step-two.phone.error'),
            'info': magicCommon.translate('sign-up-step-two.mobile.hint'),
        },
        dynamicProperties: {
            'phone-validator': getPhoneValidator(fieldConfig),
        },
        isStandAlone: true,
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        triggers: {
            country: onCountryChange(fieldConfig),
        },
        preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            var countries;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'getCountries')()];
                    case 1:
                        countries = (_a.sent());
                        return [2 /*return*/, magicCommon.getPreloadedPrefix(countries)];
                }
            });
        }); },
        converter: function (formValue) {
            var _a;
            var _b = magicCommon.convertPhoneValue((_a = formValue.phone) === null || _a === void 0 ? void 0 : _a.value), phonePrefix = _b[0], phone = _b[1];
            return {
                phonePrefix: phonePrefix,
                phone: phone,
                mobile: phone,
                mobilePrefix: phonePrefix,
            };
        },
    };
}

exports.phone = phone;
